<template lang="pug">
v-menu.suus__timepicker(
    ref="menu",
    v-model="menu",
    :close-on-content-click="false",
    :nudge-right="40",
    transition="scale-transition",
    offset-y,
    max-width="290px",
    min-width="290px"
)
    template(v-slot:activator="{ on, attrs }") 
        v-text-field.suus__text-field(
            :value="time",
            placeholder="Zeit auswählen",
            color="primary",
            filled,
            persistent-placeholder,
            background-color="lightGrey",
            v-bind="attrs",
            v-on="on",
            clearable,
            @change="handleTextInput",
            @click:clear="onClear",
            :rules="rules"
        )
            template(v-slot:prepend)
                v-icon(color="primary") {{ timeIcon }}
            template(v-slot:label)
                span(:style="labelStyles") {{ label }}
                span(v-if="isMandatory", :style="mandatoryStyles") *
    v-time-picker.mt-4(
        elevation="15",
        scrollable,
        v-model="time",
        format="24hr",
        @input="onInput",
        @change="closeMenu",
        :min="minTime",
        :max="maxTime"
    )
</template>

<script lang="ts">
import Vue from "vue"
import { mdiClockOutline } from "@mdi/js"

export default Vue.extend({
  data() {
    return {
      time: this.value,
      menu: false,
      timeIcon: mdiClockOutline,
      hour: null,
      minute: null,
    }
  },
  props: {
    label: { type: String, default: "Zeit" },
    isMandatory: { type: Boolean, default: true },
    value: { type: String, default: null },
    minTime: { type: String, default: undefined },
    maxTime: { type: String, default: undefined },
    rules: { type: Array, default: () => [] },
  },
  watch: {
    value(val) {
      this.time = val
    },
  },
  computed: {
    labelStyles(): object {
      return {
        color: this.$vuetify.theme.themes.light.primary,
        fontSize: "1.1rem",
        fontWeight: 400,
        top: "14px",
      }
    },
    mandatoryStyles(): object {
      return {
        color: "red",
        fontWeight: 400,
      }
    },
  },
  methods: {
    closeMenu() {
      this.menu = false
    },
    onInput(val) {
      this.$emit("input", val)
    },
    onClear() {
      this.$emit("input", null)
    },
    handleTextInput(value: string) {
      const isValidTime = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value)
      if (isValidTime) {
        this.time = value
        this.$emit("input", value)
      }
    },
  },
})
</script>

<style lang="sass">
%font-stack
    font-family: system-ui !important
.suus__timepicker
    @extend %font-stack
.suus__text-field
    @extend %font-stack
    .v-input__slot
        .v-text-field__slot
            input
                margin-top: 24px !important
                @extend %font-stack
                font-size: 1em !important
</style>
